'use strict';

(function() {
  const module = angular.module('client.components');

  controller.$inject = ['$window'];

  function controller($window) {
    const ctrl = this;

    ctrl.onOpenSkill = function(params) {
      const skillKey = params && params.skillKey;

      if (!skillKey) {
        return;
      }

      const skillPath = '/academy/skill/' + encodeURIComponent(skillKey);
      $window.open($window.location.origin + skillPath, '_blank');
    };
  }

  module.component('xpAcademy', {
    template: require('./academy.jade'),
    controller,
  });
})();
